/* eslint-disable max-len */
import React from 'react';

const Tags: React.FC<object> = () => {

    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_12840_322326)">
                <path
                    d="M10.5 0C12.433 0 14 1.567 14 3.5V10.5C14 12.433 12.433 14 10.5 14H3.5C1.567 14 0 12.433 0 10.5V3.5C0 1.567 1.567 0 3.5 0H10.5ZM4.77441 4.5H2.90234L2.76367 5.75H4.63477L4.35742 8.25H2.48633L2.34766 9.5H4.21875L4.00977 11.375H5.26758L5.47656 9.5H7.96875L7.75977 11.375H9.01758L9.22656 9.5H11.0967L11.2363 8.25H9.36523L9.64258 5.75H11.5137L11.6523 4.5H9.78125L9.99023 2.625H8.73242L8.52441 4.5H6.03125L6.24023 2.625H4.98242L4.77441 4.5ZM8.38477 5.75L8.10742 8.25H5.61523L5.89258 5.75H8.38477Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_12840_322326">
                    <rect width="14" height="14" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default Tags;